// includes old credit type values for existing customers, will eventually phase out
export default {
  a: {
    label: 'Excellent',
    subLabel: '(740 - 900)',
    decodedValue: 'excellent'
  },
  b: {
    label: 'Very Good',
    subLabel: '(700 - 739)',
    decodedValue: 'verygood'
  },
  c: {
    label: 'Good',
    subLabel: '(670 - 699)',
    decodedValue: 'good'
  },
  d: {
    label: 'Fair',
    subLabel: '(630 - 669)',
    decodedValue: 'fair'
  },
  e: {
    label: 'Rebuilding',
    subLabel: '(580 - 629)',
    decodedValue: 'rebuilding'
  },
  f: {
    label: 'Needs Work',
    subLabel: '(<580)',
    decodedValue: 'needswork'
  },
  excellent: {
    label: 'Excellent',
    subLabel: '(740 - 900)',
    decodedValue: 'excellent'
  },
  verygood: {
    label: 'Very Good',
    subLabel: '(700 - 739)',
    decodedValue: 'verygood'
  },
  good: {
    label: 'Good',
    subLabel: '(670 - 699)',
    decodedValue: 'good'
  },
  fair: {
    label: 'Fair',
    subLabel: '(630 - 669)',
    decodedValue: 'fair'
  },
  rebuilding: {
    label: 'Rebuilding',
    subLabel: '(580 - 629)',
    decodedValue: 'rebuilding'
  },
  needswork: {
    label: 'Needs Work',
    subLabel: '(<580)',
    decodedValue: 'needswork'
  }
};